module.exports = __webpack_public_path__ + "static/media/tip_text_dog_temperature_fr.708329da.svg";